import React, { Suspense } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { IDPAnonymous } from '@saviynt/external';
const queryClient = new QueryClient();

export default function IdentitiesVerification() {
  return (
    <QueryClientProvider client={queryClient}>
      <Suspense key="External" fallback={<>test</>}>
        <Router basename={'/ECMv6/identities'}>
          <Route path="/idproofing/request" component={IDPAnonymous} />
        </Router>
      </Suspense>
    </QueryClientProvider>
  );
}
